import { ArrowRight, ScanText } from "lucide-react";
import { Link } from "react-router-dom";

export function Hero() {
  return (
    <section className="mx-auto max-w-5xl px-5 pt-14 pb-12 text-center sm:px-6 sm:pt-20 sm:pb-16 lg:pt-24">
      <p className="mb-4 font-mono text-[10px] uppercase tracking-widest text-[var(--color-ink-muted)] sm:text-xs">
        PPTX · PDF · JSON · Layout · AI
      </p>
      <h1 className="mb-5 break-keep font-display text-[1.95rem] font-medium leading-[1.2] tracking-tight sm:mb-6 sm:text-5xl sm:leading-[1.15] md:text-6xl">
        PowerPoint と PDF の中身を、
        <br className="hidden sm:block" />
        <span className="inline-block text-[var(--color-coral)]">見える化する。</span>
      </h1>
      <p className="mx-auto mb-8 max-w-2xl text-[15px] leading-relaxed text-[var(--color-ink-muted)] sm:mb-10 sm:text-lg">
        .pptx / .pdf をアップロードすると、スライドを構造化 JSON に分解したり、ページの
        レイアウト（テキスト・図表・写真の位置と種別）を解析できます。AI に渡して編集し、 PowerPoint
        に戻す・PDF から新規生成する —— そんなワークフローをブラウザだけで試せます。
      </p>
      <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
        <Link
          to="/app"
          className="inline-flex h-12 items-center justify-center gap-2 rounded-[10px] bg-[var(--color-coral)] px-6 text-base font-medium text-white shadow-[var(--shadow-sm)] transition hover:bg-[var(--color-coral-dark)] hover:shadow-[var(--shadow-md)]"
        >
          今すぐ試す <ArrowRight size={16} />
        </Link>
        <Link
          to="/layout"
          className="inline-flex h-12 items-center justify-center gap-2 rounded-[10px] border border-[var(--color-border)] bg-[var(--color-surface)] px-6 text-base font-medium text-[var(--color-ink)] transition hover:bg-[var(--color-surface-muted)]"
        >
          <ScanText size={16} />
          レイアウト解析
        </Link>
        <Link
          to="/about"
          className="inline-flex h-12 items-center justify-center rounded-[10px] px-6 text-base font-medium text-[var(--color-ink-muted)] transition hover:text-[var(--color-ink)]"
        >
          このアプリについて
        </Link>
      </div>
      <p className="mt-5 text-sm text-[var(--color-ink-muted)] sm:mt-6">
        手元に資料がなくても、
        <Link
          to="/app"
          state={{ autoSample: true }}
          className="font-medium text-[var(--color-coral)] underline-offset-4 hover:underline"
        >
          サンプル（事業提案スライド）で試せます
        </Link>
        。
      </p>
    </section>
  );
}
